export const isEmpty = (value: any): boolean => {
    return [undefined, null, ""].includes(value);
};
